export const fishStew = {
  id: "fishStew",
  link: "/#/recipes/recipes/fishStew",
  name: "Horneater Fish Soup",
  cuisine: "Horneater",
  summary: "Tilapia and root vegetables in a clear broth",
  inspiration: "Ukha",
  quantity: "6 servings",
  time: "30 minutes",
  notes:
    'Though the books called this a fish stew, I decided to go with a soup instead. I went this direction for two reasons. First, the books use the word "stew" a lot, even when something is clearly a soup (for example a "clear stew" in The Way of Kings ch 29). The second reason is that in my research I came across Ukha, a Russian fish soup with a clear broth, which just felt right. It was also nice to have this dish be a little different from Rock\'s stew, since it was cooked by Cord, and while at sea with different ingredients available. As for the unique blend of spices Rysn mentions, I chose to use dill and caraway, again drawing from Russian influences for Horneater food.',
  quotes:
    "It was good. Fish stew, with a unique blend of spices she'd come to associate with the Horneater woman's meals. (Dawnshard ch 9)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/fish-stew-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "seafoodStock",
          display: "6 cups seafood stock"
        },
        {
          item: "turnip",
          display: "1 lb turnips"
        },
        {
          item: "celeriac",
          display: "1 lb celeriac (celery root)"
        },
        {
          item: "onion",
          display: "1 onion"
        },
        {
          item: "salt",
          display: "3/4 tsp salt"
        },
        {
          item: "dill",
          display: "1/2 tsp dried dill"
        },
        {
          item: "caraway",
          display: "1 tsp caraway seeds"
        },
        {
          item: "bayLeaves",
          display: "4 bay leaves"
        },
        {
          item: "blackPepper",
          display: "1/4 tsp ground black pepper"
        },
        {
          item: "tilapia",
          display: "1 lb tilapia fillets"
        },
        {
          item: "lemon",
          display: "1/2 tbsp lemon juice"
        }
      ]
    }
  ],
  steps: [
    "Pour the seafood stock into a large pot. Peel the celeriac. Chop the celeriac and turnip to half inch cubes. Peel and chop the onion. Add the celeriac, turnip, and onion to the pot. Also add the salt, dill, caraway seeds, bay leaves and black pepper. Cover the pot and bring to a roiling boil over high heat. Boil for 10 minutes or until vegetables are tender.",
    "Meanwhile, cut the tilapia fillets into bite size pieces. Once the vegetables in the pot are cooked, add the tilapia to the pot along with the lemon juice. Stir very gently to avoid breaking up the fish. Cook for 5 more minutes over medium high heat until the fish is flaky and cooked through. The soup does not need to come back to a boil for the fish to be cooked.",
    "Remove the bay leaves and serve."
  ]
}
